// Asks the back and reads the answer as JSON. data is undefined when the
// request did not get through or the body is not JSON: with DEBUG=False the
// back answers a 500 with an HTML page, and calling res.json() on it used to
// reject with nobody listening, which left the loader on and said nothing.
export const request = async (url, options) => {
  let res;
  try {
    res = await fetch(url, options);
  } catch (e) {
    return { ok: false, status: 0, data: undefined };
  }
  let data;
  try {
    data = await res.json();
  } catch (e) {
    data = undefined;
  }
  return { ok: res.ok, status: res.status, data };
};

// The code the back sends beside the sentence a person reads (its handoff of
// 2026-09-24). The code is the contract; the sentence is Spanish for the
// client and may be reworded, which is exactly what used to send the portal
// to its generic branch without anything failing.
export const hasCode = (answer, code) => Boolean(answer.data && answer.data['code'] === code);

// The back's answer when the five-minute access token has run out.
export const tokenExpired = (answer) => Boolean(answer.data && answer.data['code'] === 'token_not_valid');
